import { defineMessages } from 'react-intl';

export default defineMessages({
  description: {
    id: 'sentinel.components.updateAmountForm.description',
    defaultMessage: 'Description {index}',
  },
  editWireDescriptions: {
    id: 'sentinel.components.updateAmountForm.editWireDescriptions',
    defaultMessage: 'Descriptions',
  },
  updateWire: {
    id: 'sentinel.components.updateAmountForm.updateWire',
    defaultMessage: 'Update',
  },
  max: {
    id: 'sentinel.components.updateAmountForm.max',
    defaultMessage: '(30 characters max)',
  },
});



// WEBPACK FOOTER //
// ./src/components/UpdateWireDescriptionsForm/messages.js